export const defaultTravellerQuantity = {
  adult: {
    quantity: 1,
  },
  child: {
    quantity: 0,
  },
}

export const MAX_TRAVELLERS = 6
